import { Box, VStack } from '@chakra-ui/react'
import { NodeProps } from '@xyflow/react'
import React from 'react'

import { ExtensionInstance } from '@mangovoice/types'

import { ConferenceRoomNodeData } from '../../converters/shared/reactFlowTypes'
import { useSwitchboardT } from '../../types'
import { text } from '../../utils/text'
import { ConferenceRoomSelector } from '../core/ConferenceRoomSelector'
import { BaseNode, nodePropsAreEqual } from './BaseNode'
import { useConferenceRoomNode } from './hooks/useConferenceRoomNode'

export interface ConferenceRoomNodeProps extends NodeProps {
  extensionMap?: Map<number, ExtensionInstance>
  onDelete?: () => void
  onDeleteNode?: (nodeId: string) => void
  showDeleteButton?: boolean
  // Note: extensionsList is provided via Jotai atoms (extensionsListAtom)
  // Use useSwitchboardDataAtoms hook in the consuming app to set atoms
}

const ConferenceRoomNodeComponent: React.FC<ConferenceRoomNodeProps> = ({
  id,
  data,
  extensionMap: _extensionMap, // Reserved for future use
  onDelete,
  onDeleteNode,
  showDeleteButton,
}) => {
  const nodeData = data as ConferenceRoomNodeData & Record<string, unknown>
  const { currentConferenceRoomId, handleConferenceRoomChange, hasData } =
    useConferenceRoomNode(id, nodeData)
  const t = useSwitchboardT()

  return (
    <BaseNode
      label={text(
        t,
        'switchboard.nodeLabels.conference_room',
        'CONFERENCE ROOM',
      )}
      showPlaceholder={!hasData}
      onDelete={onDelete}
      onDeleteNode={onDeleteNode}
      id={id}
      showDeleteButton={showDeleteButton}
      sourceHandlePosition={null}
    >
      <VStack align="stretch" gap={3}>
        <Box>
          <ConferenceRoomSelector
            value={currentConferenceRoomId}
            onChange={handleConferenceRoomChange}
            placeholder={text(
              t,
              'switchboard.core.selectConferenceRoom',
              'Select conference room...',
            )}
          />
        </Box>
      </VStack>
    </BaseNode>
  )
}

export const ConferenceRoomNode = React.memo(
  ConferenceRoomNodeComponent,
  nodePropsAreEqual,
)
